<template>
  <v-container id="vms" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{ $t("vms") }}</div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <!-- <v-col cols="12">
                  <v-text-field
                    v-model="vmsData.type"
                    :label="$t('vms') + ' ' + $t('type')"
                  ></v-text-field>
                </v-col> -->

                <v-col cols="12">
                  <v-text-field
                    v-model="vmsData.ip"
                    :label="$t('ip')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="vmsData.port"
                    :label="$t('port')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="vmsData.username"
                    :label="$t('username')"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="vmsData.password"
                    :label="$t('password')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn color="primary" class="mr-0" @click="addVms">
                    {{ $t("update") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getVms, addVms } from "@/endpoint/vms";

export default {
  name: "Vms",
  data() {
    return {
      vmsData: {
        type: "",
        ip: "",
        port: "",
        username: "",
        password: "",
      },
      vmsItem: {
        type: "",
        ip: "",
        port: "",
        username: "",
        password: "",
      },
    };
  },
  created() {
    this.init(this);
  },
  methods: {
    async init(scope) {
      scope.vmsItem = await getVms();
      scope.vmsItem.password = "";
      scope.vmsData = JSON.parse(JSON.stringify(scope.vmsItem));
    },
    addVms() {
      let data = {};

      data.ip = this.vmsData.ip;

      data.port = this.vmsData.port;

      data.username = this.vmsData.username;

      data.password = btoa(this.vmsData.password);

      addVms(data).then(this.$router.go());
    },
  },
};
</script>
